import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom'
import { getLink } from "../../dataProvider/links.js"
import { loginUser } from "../../actions/user.js"
import { connect } from 'react-redux'
import { error as logError } from "../../logger.js";
import qs from 'qs';

function LoginRedirect(props) {

    const { i18n } = useTranslation();
    let navigate = useNavigate();
    let location = useLocation();

    useEffect(() => {

        const login = () => {
            const params = qs.parse(location.search, { ignoreQueryPrefix: true });
            const username = params.username || params.email
            const password = params.password
            props.dispatch(loginUser(username, password))
                .catch((error) => {
                    logError(error)
                })
        }

        if (props.user && props.user.connected) {
            const redirect = qs.parse(location.search, { ignoreQueryPrefix: true }).redirect
            if (redirect) {
                return navigate(getLink(redirect, i18n.language));
            } else {
                return navigate(getLink('home', i18n.language));
            }
        } else {
            login()
        }
    }, [props, i18n.language, navigate, location.search]);

    return (
        <div className="text-center" style={{ padding: "100px 0 300px" }}>
            <div className="spinner-border" />
        </div>
    )
}

const mapStateToProps = state => ({ user: state.user.user });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(LoginRedirect);